'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:ModalLicenseEntryCtrl
 * @description
 * # ModalLicenseEntryCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
	.controller('ModalLicenseEntryCtrl', function ($scope, api, product) {
		$scope.product = product;

		$scope.modalState = {
			rememberMe: true
		};

		$scope.license = $scope.$root.license || {
			licenseKey: localStorage.getItem('licenseKey'),
			registeredTo: localStorage.getItem('registeredTo')
		};

		$scope.lookupLicense = function () {
			if ($scope.myForm.$invalid) {
				return;
			}
			api.getLicense($scope.license.licenseKey, $scope.license.registeredTo, product?.id, $scope.modalState.rememberMe)
				.then(function(result) {
					console.log('getLicense returned', result);
					$scope.$root.license = $scope.license;
					$scope.$close($scope.license);
				})
		};
	});
